export function AppBoot() {
  return (
    <div aria-live="polite" className="app-boot" role="status">
      <span className="app-boot__glow" aria-hidden />
      <img
        alt="Tilt Racing"
        height="180"
        src="/app/static/themes/monkeytilt/tilt-racing-logo.png"
        width="300"
      />
      <span>Preparing the world…</span>
    </div>
  );
}
